import MeetingCancellationInfo from './MeetingCancellationInfo';
import MeetingDetails from './MeetingDetails';
import MeetingRequestConflicts from './MeetingRequestConflicts';
import MeetingRequestInfo from './MeetingRequestInfo';
import MeetingResponseInfo from './MeetingResponseInfo';
import { MeetingRequestViewState } from '../store/schema/MeetingRequestViewState';
import isMeetingCancellation from '../utils/isMeetingCancellation';
import isMeetingMessage from '../utils/isMeetingMessage';
import isMeetingRequest from '../utils/isMeetingRequest';
import isMeetingResponse from '../utils/isMeetingResponse';
import logMeetingMessageAction from '../utils/logMeetingMessageAction';
import MeetingMessageActionEntrySource from '../store/schema/MeetingMessageActionEntrySource';
import { observer } from 'mobx-react';
import MeetingMessage from 'owa-service/lib/contract/MeetingMessage';
import { lazyCloseConflictsView } from 'owa-time-panel';
import * as React from 'react';

const styles = require('./MeetingMessageInfo.scss');

export interface MeetingMessageInfoProps {
    item: MeetingMessage;
    viewState: MeetingRequestViewState;
    entrySource: MeetingMessageActionEntrySource;
    onDidMount?: () => void;
    groupId?: string;
}

@observer
export default class MeetingMessageInfo extends React.Component<MeetingMessageInfoProps, {}> {
    public componentDidMount() {
        if (this.props.onDidMount) {
            this.props.onDidMount();
        }

        const { item, entrySource } = this.props;
        logMeetingMessageAction('ViewOpened', item, entrySource);
    }

    public componentWillUnmount() {
        const { item, entrySource } = this.props;
        logMeetingMessageAction('ViewClosed', item, entrySource);
        lazyCloseConflictsView.importAndExecute();
    }

    render() {
        if (!isMeetingMessage(this.props.item)) {
            return null;
        }

        const { item, viewState, entrySource } = this.props;

        return (
            <div className={'allowTextSelection'}>
                <div className={styles.container}>
                    <MeetingDetails item={item} />
                    <MeetingRequestConflicts
                        item={item}
                        viewState={viewState}
                        entrySource={entrySource}
                    />
                    {this.getComponentForItemType()}
                </div>
            </div>
        );
    }

    private getComponentForItemType() {
        const { item, viewState, entrySource, groupId } = this.props;

        const itemClass = item.ItemClass;

        if (isMeetingResponse(itemClass)) {
            return <MeetingResponseInfo item={item} entrySource={entrySource} />;
        } else if (isMeetingRequest(itemClass)) {
            return (
                <MeetingRequestInfo
                    item={item}
                    viewState={viewState}
                    entrySource={entrySource}
                    groupId={groupId}
                />
            );
        } else if (isMeetingCancellation(itemClass)) {
            return (
                <MeetingCancellationInfo item={item} groupId={groupId} entrySource={entrySource} />
            );
        } else {
            // Default case until all other cases are covered
            return null;
        }
    }
}
